
// eslint-disable-next-line import/prefer-default-export
export const GenericItemMixin = {
  props: {
    idPrefix: {
      type: String,
      required: false,
    },
    researchItem: {
      type: Object,
      required: true,
    },
    asAnswer: {
      // This renders the item as an answer (no data can be modified anymore);
      type: Boolean,
      default() {
        return false;
      },
    },
    small: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
};
